import { Injectable } from '@angular/core';

import { NavController } from '@ionic/angular';
import { PermissionService } from '@app/core/services';
import { USER_ACCESS_PERMISSION } from '../constants/permissions.constants';

@Injectable()
export class UserAccessGuard  {
  constructor(
    private _permissionService: PermissionService,
    private _navController: NavController,
  ) {}

  canActivateChild(): boolean {
    const hasPermission = this._permissionService.doesUserHavePermission(
      USER_ACCESS_PERMISSION,
    );
    if (!hasPermission) {
      this._navController.navigateRoot(['restricted']);
    }
    return hasPermission;
  }
}
